import React, { useState } from "react";

const TimeSlotPicker = ({ times, setSelectedTime, selectedTime }) => {
  return (
    <div className="p-4">
      <h5 className="text-lg font-semibold mb-2">Select a Time Slot</h5>
      <div className="grid grid-cols-4 gap-3">
        {times.map((time) => {
          const isSelected = selectedTime === time;
          return (
            <button
              key={time}
              onClick={() => setSelectedTime(time)}
              className={`m-2 rounded-lg border text-sm font-medium transition 
                ${
                  isSelected
                    ? "bg-primary text-white border-blue-600"
                    : "border-gray-300 hover:bg-gray-100"
                }`}
            >
              {time.slice(0, 5)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TimeSlotPicker;
